import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Select from 'react-select';
import { fetchRegions, fetchPlaceTypes } from '../api';

const SearchBar = ({ onSearch }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [regions, setRegions] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        loadFilters();
        // Инициализация значений из URL
        const regionId = searchParams.get('region');
        const typeId = searchParams.get('type');
        const query = searchParams.get('query');

        if (regionId) {
            setSelectedRegion({ value: regionId, label: '' });
        }
        if (typeId) {
            setSelectedType({ value: typeId, label: '' });
        }
        if (query) {
            setSearchQuery(query);
        }
    }, [searchParams]);

    const loadFilters = async () => {
        try {
            const [regionsResponse, typesResponse] = await Promise.all([
                fetchRegions(),
                fetchPlaceTypes()
            ]);

            // Проверяем структуру ответа и преобразуем данные
            const regionsData = Array.isArray(regionsResponse) ? regionsResponse : 
                              regionsResponse.data ? regionsResponse.data : [];
            
            const typesData = Array.isArray(typesResponse) ? typesResponse : 
                            typesResponse.data ? typesResponse.data : [];

            const formattedRegions = regionsData.map(region => ({
                value: region.id,
                label: region.name
            }));

            const formattedTypes = typesData.map(type => ({
                value: type.id,
                label: type.name
            }));

            setRegions(formattedRegions);
            setTypes(formattedTypes);

            // Обновляем метки для выбранных значений
            const regionId = searchParams.get('region');
            const typeId = searchParams.get('type');

            if (regionId) {
                const region = formattedRegions.find(r => r.value === regionId);
                if (region) {
                    setSelectedRegion(region);
                }
            }

            if (typeId) {
                const type = formattedTypes.find(t => t.value === typeId);
                if (type) {
                    setSelectedType(type);
                }
            }
        } catch (err) {
            console.error('Error loading filters:', err);
            setRegions([]);
            setTypes([]);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        const params = new URLSearchParams();
        
        if (selectedRegion) {
            params.set('region', selectedRegion.value);
        }
        if (selectedType) {
            params.set('type', selectedType.value);
        }
        if (searchQuery) {
            params.set('query', searchQuery);
        }

        navigate(`/?${params.toString()}`);
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '42px',
            borderColor: 'var(--border-color)',
            '&:hover': {
                borderColor: 'var(--primary-color)'
            }
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? 'var(--primary-color)' : state.isFocused ? 'var(--background-color)' : 'white',
            color: state.isSelected ? 'white' : 'var(--text-primary)',
            '&:hover': {
                backgroundColor: state.isSelected ? 'var(--primary-color)' : 'var(--background-color)'
            }
        })
    };

    return (
        <form onSubmit={handleSearch} className="search-container">
            <div className="search-input-group">
                <input
                    type="text"
                    className="search-input"
                    placeholder="Поиск по названию или описанию..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            <div className="search-selects">
                <div className="search-select">
                    <Select
                        placeholder="Выберите регион..."
                        options={regions}
                        value={selectedRegion}
                        onChange={setSelectedRegion}
                        isClearable
                        styles={customStyles}
                    />
                </div>
                <div className="search-select">
                    <Select
                        placeholder="Выберите тип места..."
                        options={types}
                        value={selectedType}
                        onChange={setSelectedType}
                        isClearable
                        styles={customStyles}
                    />
                </div>
            </div>
            <button type="submit" className="btn btn-primary">
                Найти
            </button>
        </form>
    );
};

export default SearchBar; 